import React from 'react';
import cx from 'classnames';
import { getHolidayTypes } from '../../../utils/park-static-data/defaultData';
import SelectButton from '../../SearchForm/children/SelectButton';
import styles from './holidayTypeSelector.module.scss';
export const HolidayTypeSelect = ({ onChange, holidayTypes = getHolidayTypes(), value = null, isFiltersColumn = false, }) => {
    return (<>
      <div>
        <ul className={styles.list}>
          {holidayTypes === null || holidayTypes === void 0 ? void 0 : holidayTypes.map(({ name, value: code }) => {
            return (<li className={cx(styles.item, {
                    'bl-haven-holidayTypeSelector__item-filtersColumn': isFiltersColumn,
                })} key={code}>
                <SelectButton key={name} value={name} onClick={() => onChange(code, name)} checked={value === code}/>
              </li>);
        })}
        </ul>
      </div>
    </>);
};
export default HolidayTypeSelect;
